var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLedger = function SvgLedger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 21,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5A6A",
    d: "M19 3h-6.6l-3-3H3C1.3 0 0 1.3 0 3v15c0 1.7 1.3 3 3 3h16c1.7 0 3-1.3 3-3V6c0-1.7-1.3-3-3-3M3 2h5.6l3 3H19c.6 0 1 .4 1 1H2V3c0-.6.4-1 1-1m16 17h-7v-1c1.1 0 2-.9 2-2v-1c0-1.1-.9-2-2-2h-2v-1h4v-2h-2V9h-2v1c-1.1 0-2 .9-2 2v1c0 1.1.9 2 2 2h2v1H8v2h2v1H3c-.6 0-1-.4-1-1V8h18v10c0 .6-.4 1-1 1"
  })));
};
export default SvgLedger;